<template>
  <div class="page-container">
    <section class="mt-4 mb-10">
      <h1 class="font-size--24" style="word-break: keep-all">
        상점 분석을 통해 진행 가능 여부를 파악하고 있습니다.<br />
        <br />
        진행 가능 여부는<br />
        문자로 안내 드릴 예정입니다. <br />
      </h1>
      <v-footer fixed>
        <v-layout :class="{ 'px-3': !$vuetify.breakpoint.mobile }">
          <BasicButton class="button next-button" depressed height="48" @click="next">
            확인
          </BasicButton>
        </v-layout>
      </v-footer>
    </section>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { defaultApi } from '@/plugins/api/defaultApi'
import { redirectSignupManage } from '@/util/signupManage'
export default {
  computed: {
    ...mapState('auth', ['me']),
    ...mapGetters('auth', ['referralCode', 'registerWooriCrowd']),
    redirectPath() {
      let redirectPath = '/earlyPay'
      if (this.referralCode) {
        redirectPath = '/kyc/verify-id/confirm'
      }

      if (this.$route.query?.redirectPath) {
        redirectPath = this.$route.query.redirectPath
      }

      return redirectPath
    },
  },
  async created() {
    console.log('SUCCESS VUEW!!!!')
    _meta({
      titles: ['신용평가성공'],
    })
    if (await redirectSignupManage()) {
      return
    }
  },
  watch: {
    me: {
      deep: true,
      immediate: true,
      async handler() {
        const type = 'woori_crowd'

        if (
          this.me?.acquisitionRoute?.name?.includes(type) ||
          this.me?.acquisitionRoute?.name?.includes('woori-crowd') ||
          ['cafepainceo', 'sellarajit', 'sinsinmnc'].includes(this.me?.acquisitionRoute?.name)
        ) {

          console.log('SUCCESS VUEW type!!!!', type)
          const { data } = await this.storeGetRequests({ type })
          let loansRequest
          if (data.length > 0) {
            loansRequest = data[0]
          } else {
            loansRequest = await this.storeAddRequest({
              amount: 10000000, // 요청금액 disbursements의 합과 같아야 한다. // 보통의 경우 자신의 출금계좌로 넣어서 요청
              type, // creditpay:외상, woori_crowd: 우리동네크라우드펀딩
              interestRate: 0.1,
              overdueInterestRate: 0.13,
              repaymentRatio: 0.1,
              commissionRate: 0.025,
              repaymentPeriodInDays: 180,
              disbursements: [],
            })
          }
          // 작성한 파일 확인
          const { data: files } = await defaultApi.getLoansRequestFiles(loansRequest.uuid)
          // 2개가 작성된게 아니라면 이동시킨다.
          if (files.filter((f) => ['사업참여신청서', '자가진단표'].includes(f.title)).length < 2) {
            await this.$router.replace(`/signup/woori-crowd/${loansRequest.uuid}/application`)
          }
        }
      },
    },
  },
  methods: {
    ...mapActions('auth', ['getMe']),
    ...mapActions('loansRequest', {
      storeAddRequest: 'addRequest',
      storeGetRequests: 'getRequests',
    }),
    async next() {
      await this.$router.push(this.redirectPath)
    },
  },
}
</script>
<style lang="scss" scoped>
#section__success {
  .v-card {
    background-color: #f4faff;
  }
}
</style>
